import React from "react";
import PropTypes from "prop-types";
import {makeStyles, Typography, Box} from "@material-ui/core";
import {Skeleton} from "@material-ui/lab";
import {retrieveContentfulImage} from "../../../common/image";
import ResponsiveDialog from "../../widget/dialog/ResponsiveDialog";
import CustomRichText from "../../widget/text/CustomRichText";


const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiDialogActions-root": {
            display: "block",
            margin: 0,
            padding: theme.spacing(3),
            borderTop: "1px solid " + theme.palette.borders.line.lighter,
        },
        "& .MuiDialogActions-spacing > :not(:first-child)": {
            marginLeft: 0
        }
    },
    image: {
        width: "100%",
        borderRadius: theme.spacing(1),
        objectFit: "cover",
        maxHeight: theme.spacing(40),
    },
    content: {
        whiteSpace: "pre-line",
        "& p+p": {
            marginTop: theme.spacing(2)
        },
    }
}));

const ResortServiceDetailsDialog = ({isOpen, onClose, entry, extraInput, actions}) => {

    const classes = useStyles();

    return (
        <ResponsiveDialog
            open={isOpen}
            handleClose={onClose}
            disableBackdropClick={false}
            hasCloseButton
            maxWidth="sm"
            content={(
                <>
                    <Typography
                        variant="h1"
                        gutterBottom
                        align="center"
                    >
                        {!entry ? <Skeleton/> : entry.title}
                    </Typography>

                    {!entry ? (
                        <Skeleton
                            variant="rect"
                            height={318}
                        />
                    ) : (
                        <img
                            alt={entry?.title}
                            src={entry?.image?.url ? retrieveContentfulImage(entry?.image?.url, { width: 600, fit: "fill" }) : `/images/service_packagetype_${entry?.packageType}.jpg`}
                            className={classes.image}
                        />
                    )}

                    <Box
                        my={3}
                        className={classes.content}
                    >
                        {!entry ? <><Skeleton/><Skeleton/><Skeleton/><Skeleton/></> : <CustomRichText document={entry?.fullDescription?.json}/>}
                    </Box>

                    {extraInput}
                </>
            )}
            actions={!entry ? <Skeleton/> : actions}
            className={classes.root}
        />
    );
};

ResortServiceDetailsDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    entry: PropTypes.object,
    extraInput: PropTypes.element,
    actions: PropTypes.element,
};

export default ResortServiceDetailsDialog;

